type InstallChoice = { outcome: "accepted" | "dismissed"; platform: string };

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<InstallChoice>;
}

let deferredPrompt: BeforeInstallPromptEvent | null = null;

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredPrompt = event as BeforeInstallPromptEvent;
  });
}

export function isInstalled() {
  const standaloneNavigator = navigator as Navigator & { standalone?: boolean };
  return window.matchMedia("(display-mode: standalone)").matches || standaloneNavigator.standalone === true;
}

export async function requestInstall(): Promise<"accepted" | "dismissed" | "unavailable"> {
  if (!deferredPrompt) return "unavailable";
  const prompt = deferredPrompt;
  deferredPrompt = null;
  await prompt.prompt();
  const choice = await prompt.userChoice;
  return choice.outcome;
}

export function installInstructions() {
  const agent = navigator.userAgent;
  if (/MicroMessenger/i.test(agent)) {
    return "请先点击微信右上角菜单，选择“在浏览器打开”，再使用浏览器菜单中的“添加到主屏幕”。";
  }
  if (/iPhone|iPad|iPod/i.test(agent)) {
    return "在 Safari 底部点击“分享”，向上滑动并选择“添加到主屏幕”，最后点击“添加”。";
  }
  return "打开浏览器菜单，选择“安装应用”或“添加到主屏幕”；若没有该选项，请先刷新页面后重试。";
}
